/**
 * Legal template registry.
 * Imports the HTML as raw strings so the apps can render or hand off to a PDF
 * generator (Module 12) without a network call. New versions are added as new
 * files; existing files are treated as immutable historical records.
 *
 * NOTE: Vite exposes the `?raw` import query for text imports. The apps' bundlers
 * inherit this from packages/ui because they consume TypeScript source directly.
 */
import therapistAgreementEl from './therapist-agreement-el.html?raw';
import clientTosEl from './client-tos-el.html?raw';

export interface LegalTemplate {
  readonly version: string;
  readonly locale: 'el' | 'en';
  readonly title: string;
  readonly html: string;
}

export const THERAPIST_AGREEMENTS: readonly LegalTemplate[] = [
  { version: 't-v1.0', locale: 'el', title: 'Συμφωνητικό Συνεργασίας Θεραπευτή', html: therapistAgreementEl },
];

export const CLIENT_TOS: readonly LegalTemplate[] = [
  { version: 'c-v1.0', locale: 'el', title: 'Όροι Χρήσης — Πελάτης', html: clientTosEl },
];

export const CURRENT_THERAPIST_AGREEMENT = THERAPIST_AGREEMENTS[0]!;
export const CURRENT_CLIENT_TOS = CLIENT_TOS[0]!;
